import { createFileRoute } from '@tanstack/react-router';
import { ContaBloqueada } from '@/features/login/page/ContaBloqueada';

export const Route = createFileRoute('/auth/conta-bloqueada')({
    component: ContaBloqueada,
});
